import { useState } from "react";
import { SMS_CODE_RETRY_DELAY_IN_SECONDS } from "utils/envConstants";

export const useTimerState = (timeValue: number) => {
    const [timeLeft, setTimeLeft] = useState(timeValue);
    let timeLeftInterval: NodeJS.Timeout;

    const finishCountdown = () => {
        if (timeLeftInterval) {
            clearInterval(timeLeftInterval);
            setTimeLeft(0);
        }
    }

    const startCountdown = () => {
        finishCountdown();

        setTimeLeft(SMS_CODE_RETRY_DELAY_IN_SECONDS);
        const interval = setInterval(() => {
            setTimeLeft((value) => {
                if (value <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return value - 1;
            });
        }, 1000);
        timeLeftInterval = interval;
    };

    return { timeLeft, startCountdown, finishCountdown }
}